class AwardEntry {
  awardEntryId = 0;

  awardEntryName = '';

  awardShowId = 0;

  awardShowName = '';

  awardTypeId = 0;

  awardTypeName = '';

  awardSetFieldValueId = 0;

  awardCategoryName = '';

  awardSubcategoryName = '';

  year = 0;

  agencyName = '';

  holdingCompanyName = '';

  agencyNetworkName = '';

  regionName = '';

  countryName = '';

  cityName = '';

  advertiserName = '';

  advertiserBrandName = '';

  selectedSetId = '';

  internalUrl = '';

  externalUrl = '';

  constructor(awardEntry) {
    if (awardEntry != null) {
      this.awardEntryId = awardEntry.awardEntryId;
      this.awardEntryName = awardEntry.awardEntryName;
      this.awardShowId = awardEntry.awardShowId;
      this.awardShowName = awardEntry.awardShowName;
      this.awardTypeId = awardEntry.awardTypeId;
      this.awardTypeName = awardEntry.awardTypeName;
      this.awardSetFieldValueId = awardEntry.awardSetFieldValueId;
      this.awardCategoryName = awardEntry.awardCategoryName;
      this.awardSubcategoryName = awardEntry.awardSubcategoryName;
      this.year = awardEntry.year;
      this.agencyName = awardEntry.agencyName;
      this.holdingCompanyName = awardEntry.holdingCompanyName;
      this.agencyNetworkName = awardEntry.agencyNetworkName;
      this.regionName = awardEntry.regionName;
      this.countryName = awardEntry.countryName;
      this.cityName = awardEntry.cityName;
      this.advertiserName = awardEntry.advertiserName;
      this.advertiserBrandName = awardEntry.advertiserBrandName;
      this.selectedSetId = awardEntry.selectedSetId;
      this.internalUrl = awardEntry.internalUrl;
      this.externalUrl = awardEntry.externalUrl;
    }
  }

  get displayText() {
    return `${this.awardShowName}-${this.awardTypeName}-${this.year}`;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    return new AwardEntry(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => AwardEntry.fromObject(data));
  }
}

export default AwardEntry;
